export const homeBarFilter = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const filtersButton = document.querySelector('.filtersHome__button');

        if (filtersButton) {
            document.querySelectorAll('.filtersHome select').forEach(select => {
                select.addEventListener('change', function () {
                    const slug = select.getAttribute('name');
                    const value = select.value;

                    if (slug === "rodzaj-wyjazdu" && value === "none") {
                        select.classList.add('error');
                    } else {
                        select.classList.remove('error');
                    }
                });
            });

            filtersButton.addEventListener('click', function () {
                const shopPageURL = filtersButton.getAttribute('data-search-result-url');
                if (!shopPageURL) {
                    console.error('Shop URL is missing in the data-search-result-url attribute');
                    return;
                }

                let filters = [];
                let isError = false;

                document.querySelectorAll('.filtersHome select').forEach(select => {
                    const slug = select.getAttribute('name');
                    const value = select.value;

                    // If 'rodzaj-wyjazdu' is 'none', add 'error' class and prevent form submission
                    if (slug === "rodzaj-wyjazdu" && value === "none") {
                        select.classList.add('error');
                        isError = true;
                    } else {
                        select.classList.remove('error');
                    }

                    if (value && value !== "none") {
                        filters.push(`${encodeURIComponent(slug)}=${encodeURIComponent(value)}`);
                    }
                });

                if (isError) {
                    console.log('Error: "rodzaj-wyjazdu" cannot be "none".');
                    return; // Prevent redirection
                }

                // Construct the final URL with "&" separating the filters
                const queryString = filters.length > 0 ? `?${filters.join('&')}` : '';
                const finalURL = `${shopPageURL}${queryString}`;

                // Redirect to the constructed URL
                window.location.href = finalURL;
            });
        }
    });
};
